import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getInvitesCountKey } from './invites.keys';
import { getInvitesCount } from './invites.repository';
import { GetInvitesCountOutput } from './invites.types';

export const useGetInvitesCount = (options?: UseDataQueryOptions) =>
  useDataQuery<GetInvitesCountOutput>(
    {
      queryKey: getInvitesCountKey(),
      queryFn: async () => {
        const response = await getInvitesCount();
        if (!response.ok || !response.data) {
          throw response.originalError;
        }
        return response.data;
      },
    },
    options,
  );
